/*!

=========================================================
* Paper Dashboard React - v1.3.0
=========================================================

* Product Page: https://www.creative-tim.com/product/paper-dashboard-react
* Copyright 2021 Creative Tim (https://www.creative-tim.com)

* Licensed under MIT (https://github.com/creativetimofficial/paper-dashboard-react/blob/main/LICENSE.md)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.


list

*/
import React, {useState, useEffect } from "react";

import { Card, CardHeader, CardBody, Row, Col, Input } from "reactstrap";

// add new codes
import { useHistory } from 'react-router-dom';
import dataTypes from "views/diary/dataType.js";

import "assets/css/coach.css";

// end

let axios = require('axios');
let URL_API = "https://xs458763.xsrv.jp/api/";

// let images = JSON.stringify(importAll(require.context('assets/img/self/icon', false, /\.(png|jpe?g|svg)$/)));
var aTimeout = null;

window.mobileCheck = function() {
  let check = false;
  (function(a){if(/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(a)||/1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0,4))) check = true;})(navigator.userAgent||navigator.vendor||window.opera);
  return check;
};

function UserMg() {

  let session = window.sessionStorage.getItem('sessions');
  let se = JSON.parse(session);
  if(!se){
    window.location = '/';
  }

  const history = useHistory();

  const [players, setPlayers] = useState([]);

  const addPlayer = (event) => {
    toPage(event, 'addPlayer');
  }

  const toPage = (e, pname) => {
    history.push('../coach/'+pname);
  }

  const onSelectPlayer = (e, player) => {
    if(aTimeout)
      clearTimeout(aTimeout);    

    axios.get(URL_API+"checkPlayer", {
      params: {
        user: player['id']
      }
    })
    .then(function (response) {
      if(response.data == 'ok'){
        window.sessionStorage.setItem('player', JSON.stringify(player));
        toPage(e, 'player');
      }
    }).catch(
      error => {
        if(error.response){
          console.log(error.response.data);
        };
      }
    );    
  }

  const onEditSelectedPlayer= (e, item) => {
    return;
    // console.log(e, item);
    aTimeout = setTimeout(function(){
      toPage(e, 'editPlayer');
    }, 1000);
    return false;
  }

  const onEditSelectedPlayer1 = (e, item) => {
    if(window.mobileCheck())
      return;
    onEditSelectedPlayer(e, item);
  }

  useEffect(() => {
    let session = window.sessionStorage.getItem('sessions');
    let se = JSON.parse(session);
    if(!se){
      window.location = '/';
    }

    if(JSON.parse(window.sessionStorage.getItem('players')) != null){
      setPlayers(JSON.parse(window.sessionStorage.getItem('players')));
    }
    
    axios.post(URL_API+"getPlayers", {
      params: {
        user: se['id']
      }
    })
    .then(function (response) {
      // let d = JSON.parse(response);
      window.sessionStorage.setItem('players', JSON.stringify(response.data));
      setPlayers(response.data);
      // console.log(response);
    }).catch(
      error => {
        if(error.response){
          console.log(error.response.data);
        };
      }
    ); 

  }, []);

  return (
    <>      
      <div className="content px-0 pb-0">
        <div className="titleDiv">
          <Card className="mb-0">
            {/*<CardBody className="seldate p-1 d-flex" id='seldate'>
              <div className="d-flex col-12 px-2">
                <div className="col-12 text-center px-0 d-flex align-items-center justify-content-center head_title">
                    選手情報
                </div>
              </div>
            </CardBody>
            <div className="text-right p-2 my-1">
                          <span className="p-2" onClick={(event) => addPlayer(event)}><i className="fas fa-plus" style={{fontSize:'20px'}}></i></span>
                        </div>*/}
            <CardBody className="px-1 coach-user-content">
              <div className="col-12 px-0">                
                <div className="col-12 px-0 row mx-0 players">
                  {
                    players.map((player, idx) => 
                      <div key={idx} className={'col-3 p-1 mb-2 '} onTouchStart = {(event) => onEditSelectedPlayer(event, player)} onClick={(event) => onSelectPlayer(event, player)} onMouseDown = {(event) => onEditSelectedPlayer1(event, player)}>
                        <div className="text-center">
                          <img src={(player.profile_photo_path ? "https://xs458763.xsrv.jp/uploads/"+player.profile_photo_path : require("assets/img/mike.png").default)}/>
                        </div>
                        <div className="text-center mt-2">
                          <span style={{width:'100%', whiteSpace:'pre-wrap'}}>
                            {player.nickName || ''}
                            {
                              player.nickName && (
                                <br/>
                              )
                            }{player.name}
                          </span>
                        </div>                
                      </div>
                    )
                  }
                </div>
              </div>
            </CardBody>
          </Card>
        </div>
      </div>
    </>
  );
}

export default UserMg;
